export default __webpack_public_path__ + "static/media/wf-isf-perspectives-urban-forests_1164x584.08ec1aa8.jpg";